import script from "./ConfirmationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationPage.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationPage.vue?vue&type=style&index=0&id=2b8b9fca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b8b9fca"]])

export default __exports__